import IReporter from '../interfaces/IReporter';
import Reporter from './Reporter';
import IReportingEvent from '../interfaces/IReportingEvent';
import { ITrackingServerConfig, HttpMethod } from '../interfaces/ITrackingServerConfig';
import AxiosAdapter from './AxiosAdapter';

export default class AjaxReporter extends Reporter implements IReporter {
    constructor(config: ITrackingServerConfig) {
        super(config);

        this.config.url = this.initializeUrl(config.url);
    }

    async sendReport(event: IReportingEvent): Promise<void> {
        try {
            super.sendThirdPartyReport(event.type);
            const mapped: IReportingEvent = super.getMappedParams(event);

            if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
                console.log(`sendReport: ${JSON.stringify(mapped)}`);
                return;
            }

            if (this.config.method === HttpMethod.GET) {
                return this.sendGetReport(mapped);
            }
            return this.sendPostReport(mapped);
        } catch (err) {
            throw err;
        }
    }

    async sendPostReport(event: IReportingEvent): Promise<void> {
        try {
            // eslint-disable-next-line no-param-reassign
            // event = super.getMappedParams(event);

            AxiosAdapter.post(this.config.url, { ...this.config.baseParams, ...event });
            return;
        } catch (err) {
            throw err;
        }
    }

    async sendGetReport(event: IReportingEvent): Promise<void> {
        try {
            const url = super.getUrlWithQueryStringParams(event);

            AxiosAdapter.get(url);
            return;
        } catch (err) {
            throw err;
        }
    }

    private initializeUrl(url: string): string {
        if (url.indexOf('?') === -1) {
            return `${url}?`;
        }
        const lastChar = url.charAt(url.length - 1);
        if (lastChar === '&' || lastChar === '?') {
            return url;
        }
        return `${url}&`;
    }
}
